import { render, staticRenderFns } from "./FieldsMap.vue?vue&type=template&id=ddb12a2a&scoped=true&lang=pug"
import script from "./FieldsMap.vue?vue&type=script&lang=js"
export * from "./FieldsMap.vue?vue&type=script&lang=js"
import style0 from "./FieldsMap.vue?vue&type=style&index=0&id=ddb12a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb12a2a",
  null
  
)

export default component.exports